import GooglePublisherTag from "./google-publisher-tag.jsx";
import pure from "./higher-order/pure";
import React from "react";

var gameBoardBannerSizeMappings = [
  [[768, 0], [[728, 90], [468, 60]]],
  [[0, 0], [[468, 60], [320, 50], [300, 250], [300, 100], [234, 60], [88, 31]]],
];

export default pure(function GameBoardBanner({ racesForTournament, session, tournament }) {
  var banner = tournament.get("marquee_html");
  if (banner && banner.length > 0) {
    /* eslint-disable react/no-danger */
    return (
      <div className="l-wrapper batch-g batch-g--align-center" dangerouslySetInnerHTML={{ __html: banner}} />
    );
    /* eslint-enable react/no-danger */
  }

  return <BannerForSession racesForTournament={racesForTournament} session={session} tournament={tournament} />;
});

function BannerForSession({ racesForTournament, session, tournament}) {
  var targeting = {
    // breed: harness/thoroughbred
    "head2head": tournament.get("max_users") === 2,
    "logged-in": session.get("user_id") !== undefined,
    "points-game": tournament.get("points_buy_in_amount") > 0,
    "tracks": racesForTournament.map(race => race.get("track_abbreviation")).toSet().toJS(),
    "tournament-id": tournament.get("id"),
    "tournament-type": tournament.get("tournament_type"),
    "user-state": session.getIn(["billing_address", "state"])
  };

  return (
    <GooglePublisherTag
      adUnitPath={window.env.adUnitBasePath + "/game-board"}
      className="game-table_ad"
      sizeMappings={gameBoardBannerSizeMappings}
      targeting={targeting} />
  );
}
